import type { OnboardingDraft } from './types'

const DEFAULT_ONBOARDING_DRAFT: OnboardingDraft = {
  company: {
    companyName: '',
    websiteUrl: '',
    industry: '',
    employeeRange: '',
    city: '',
    postalCode: '',
  },
  strategy: {
    markenkern: '',
    positioning: '',
    mission: '',
    usp: '',
    primaryOffer: '',
    strategicGoals: [],
    proofPoints: [],
  },
  vision: {
    visionStatement: '',
    goals: [],
  },
  audience: {
    audienceSummary: '',
    decisionMakers: [],
    triggerContext: '',
  },
  tone: {
    formality: 50,
    emotionality: 50,
    technicality: 50,
    assertiveness: 50,
    verbosity: 50,
    blockedWords: 'guenstig, billig, disruptiv, Synergie',
    preferredPhrases: 'handwerklich sauber, passt genau, Termin haelt',
  },
  market: {
    competitors: ['', '', ''],
    differentiators: '',
    marketingChallenges: [],
    regionFocus: ['DACH'],
  },
  approval: {
    postingDays: ['Mo', 'Mi', 'Fr'],
    approvalMode: 'single',
  },
  newsletter: {
    sourceFileName: 'kontakte.xlsx',
    recipientCount: 426,
    validRecipientCount: 389,
    themes: ['Referenz-Projekte', 'Technik-Wissen', 'Termine & Messen'],
  },
  design: {
    template: 'Clean Minimal',
    colors: ['#1C3D6B', '#F5A623', '#FAFAF7'],
    logoName: 'logo.svg',
  },
}

export function getDefaultDraft() {
  return DEFAULT_ONBOARDING_DRAFT
}